import Vue from 'vue'

window.ui = {

    platform: 'ios',
    backButtonState: 0,
    backButtonString: 'Terug',
    viewTitle: '',
    viewTitleDefault: 'My Dubline',
    dialog: {},
    overlayToggled: false,
    backButtonCallbackData: false,

    hideBackButton(){

        this.backButtonState = 0;
    },

    showBackButton(string, title, callback){

        if(typeof callback !== 'undefined'){

            this.backButtonCallbackData = callback;
        }
        else{

            this.backButtonCallbackData = false;
        }

        if(typeof string !== 'undefined'){

            this.backButtonString = string;
        }

        if(typeof title !== 'undefined'){

            this.setViewTitle(title);
        }
        else{

            this.setViewTitle(this.viewTitleDefault);
        }

        this.backButtonState = 1;
    },

    backButtonActions(){

        var platform = this.getPlatform();

        if(this.backButtonCallbackData !== false){

            if(platform){

                if(typeof this.backButtonCallbackData[platform] !== 'undefined'){

                    this.backButtonCallbackData[platform]();
                }
                else{

                    return false;
                }
            }
            else{

                this.backButtonCallbackData();
            }

            return true;
        }

        return false;
    },

    setViewTitle(title){

        this.viewTitle = title;
    },

    showOverlay(){

        this.overlayToggled = true;
    },

    hideOverlay(){

        this.overlayToggled = false;
    },

    showDialog(title, description, cancellable, options, editable){

        this.showOverlay();

        this.dialog.state = 1;
        this.dialog.title = title;
        this.dialog.description = description;
        this.dialog.cancellable = cancellable;
        this.dialog.options = options;
        this.dialog.editable = editable;
    },

    dialogOptionClicked(key){

        var buffer = this.dialog.options[key];

        //Execute after onclick options
        if(typeof buffer.execute != 'undefined'){

            buffer.execute(this.dialog.description);
        }

        this.hideOverlay();
    },

    setPlatform(p){

        this.platform = p;
    },

    getPlatform(){

        return this.platform;
    },

    truncateText(text, length, clamp){

        clamp = clamp || '...';
        var node = document.createElement('div');
        node.innerHTML = text;

        var content = node.textContent;

        return content.length > length ? content.slice(0, length) + clamp : content;
    }
};

Vue.prototype.$ui = window.ui;



// WEBPACK FOOTER //
// ./src/assets/js/libs/ui.js